var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"uk-container uk-container-large"},[_c('div',{attrs:{"id":"kd-widget"}}),_c('b-overlay',{attrs:{"show":_vm.isAddingToCart,"fixed":true,"no-wrap":true,"rounded":"sm","opacity":0.6,"z-index":1000}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }